export const TICKET_STATE_NEW = 'Nuevo';
export const TICKET_STATE_AWAITING_CONFIRMATION = 'awaiting_confirmation';
export const TICKET_STATE_REOPENED = 'reopened';
export const TICKET_STATE_RESOLVED = 'Resuelto';
export const TICKET_STATE_CLOSED = 'Cerrado';

export const TICKET_CLOSURE_WITHOUT_CONFIRMATION = 'closed_without_confirmation';

export const TICKET_PRIORITY_HIGH = 'high';
export const TICKET_PRIORITY_MEDIUM = 'medium';
export const TICKET_PRIORITY_LOW = 'low';

export const TICKET_REJECTION_REASON_MIN_LENGTH = 10;

const BUSINESS_LINE_LABELS = {
  'Menu Diario': 'Menu Diario',
  'On Demand': 'On Demand',
  Franchises: 'Franquicias',
};

const FINISHED_STATES = [TICKET_STATE_RESOLVED, TICKET_STATE_CLOSED];

const STATE_LABELS = {
  [TICKET_STATE_AWAITING_CONFIRMATION]: 'Esperando tu confirmación',
  [TICKET_STATE_REOPENED]: 'Reabierto',
};

export const PRIORITY_LABELS = {
  [TICKET_PRIORITY_HIGH]: 'Alta',
  [TICKET_PRIORITY_MEDIUM]: 'Media',
  [TICKET_PRIORITY_LOW]: 'Baja',
};

export function businessLineLabel(line) {
  return BUSINESS_LINE_LABELS[line] || line;
}

export function isTicketFinished(state) {
  return FINISHED_STATES.includes(state);
}

export function isAwaitingConfirmation(state) {
  return state === TICKET_STATE_AWAITING_CONFIRMATION;
}

export function ticketStateLabel(ticket) {
  if (ticket.estado === TICKET_STATE_RESOLVED && ticket.closure_type === TICKET_CLOSURE_WITHOUT_CONFIRMATION) {
    return 'Cerrado sin confirmación';
  }

  return STATE_LABELS[ticket.estado] || ticket.estado;
}
